<div class="switch-workspace-modal" mat-dialog-content>
  <header class="modal-header">
    <h2 class="title-large font-brand weight-bold">{{ 'Cambiar de workspace' | translate }}</h2>
    <p class="body-medium text-secondary">
      {{ 'Elige en cuál quieres trabajar. Tu rol y tus permisos cambian según el workspace.' | translate }}
    </p>
  </header>

  <div class="workspace-list">
    @if (cargando()) {
    <!--
      El diálogo abre antes de tener la lista: el cargando va acá, donde el
      usuario está mirando, y no como una espera sin señal antes de abrir.
    -->
    <div class="cargando-workspaces" role="status" [attr.aria-label]="'Cargando' | translate">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
    } @else {
    @for (ws of workspaces(); track ws.id) {
    <app-workspace-option modo="cambio" [workspace]="ws" [seleccionado]="estaSeleccionado(ws)"
      [activo]="esElActivo(ws)" (elegir)="elegir($event)" />
    } @empty {
    <p class="body-medium text-secondary">
      {{ 'No hay otros workspaces disponibles.' | translate }}
    </p>
    }
    }
  </div>

  <div class="switch-workspace-actions" mat-dialog-actions>
    <button type="button" class="outlined" (click)="cancelar()">{{ 'Cancelar' | translate }}</button>
    <button type="button" class="filled" (click)="continuar()">{{ 'Continuar' | translate }}</button>
  </div>
</div>
